import { render, staticRenderFns } from "./informationAgreement.vue?vue&type=template&id=55b9c2ba&scoped=true"
import script from "./informationAgreement.vue?vue&type=script&lang=js"
export * from "./informationAgreement.vue?vue&type=script&lang=js"
import style0 from "./informationAgreement.vue?vue&type=style&index=0&id=55b9c2ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b9c2ba",
  null
  
)

export default component.exports